const material =
{
    material  : 'Matériau',
    separator : ' / ',
    technique : 'Technique',
    unknown   : 'Inconnu'
};

export default material ;